import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AllowedOrganizationsContent } from '../../components/AllowedOrganizations/AllowedOrganizationsContent';
import type { AudienceForm } from '../types';

type AllowedOrganizationsProps = {
  showDivider: boolean;
};

export const AllowedOrganizations = ({ showDivider }: AllowedOrganizationsProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<AudienceForm>();

  const observableAudienceName = useWatch({
    control,
    name: 'name',
  });

  return (
    <FormSection
      title={t('Allowed Partners')}
      rightColumnSize={RIGHT_COLUMN_WIDTH}
      divider={showDivider}
      description={t('The audience is shared with the following partner(s)')}
    >
      <AllowedOrganizationsContent audienceName={observableAudienceName} />
    </FormSection>
  );
};
